// @flow

import styled from 'styled-components';

/**
 * Wraps the entire page so that print-only content can take over the
 * viewport when the user invokes the browser print dialog.
 */
export const PrintWrapper = styled.div`
  @media print {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    background: #fff;
    z-index: 10000;
    padding: 32px;
  }
`;

/**
 * Children render only when printing.
 */
export const PrintOnly = styled.div`
  display: none;
  @media print {
    display: block;
  }
`;

/**
 * Children are hidden during print (e.g. action bars, side panels).
 */
export const NoPrint = styled.div`
  @media print {
    display: none;
  }
`;

/* ─── Shared print document layout components ─── */

export const PrintPage = styled.div`
  font-family: Arial, Helvetica, sans-serif;
  font-size: 12px;
  color: #42444c;
  * { box-sizing: border-box; }
`;

export const PrintDocHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  font-weight: bold;
  padding: 16px 0;
  border-bottom: 1px solid #a8acbb;
  margin-bottom: 16px;
`;

export const PrintDocHeaderTitle = styled.div`
  font-size: 20px;
`;

export const PrintDocHeaderCompany = styled.div`
  font-size: 16px;
`;

export const PrintInfoGrid = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 16px;
`;

export const PrintInfoColumn = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  & + & {
    margin-left: 32px;
  }
`;

export const PrintInfoRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 4px;
`;

export const PrintInfoLabel = styled.div`
  font-weight: bold;
  margin-right: 16px;
  white-space: nowrap;
`;

export const PrintNotes = styled.div`
  display: flex;
  flex-direction: column;
  margin: 16px 0;
`;

export const PrintItemTable = styled.table`
  margin-top: 8px;
  width: 100%;
  border-spacing: 0;
  margin-bottom: 8px;
  th {
    text-align: center;
    border-top: 1px solid #a8acbb;
    border-bottom: 1px solid #a8acbb;
    padding: 9px 4px;
    font-size: 12px;
    font-weight: bold;
  }
  th:first-of-type {
    text-align: left;
  }
  td {
    text-align: center;
    padding: 7px 4px;
    min-width: 24px;
    font-size: 12px;
    border-bottom: 1px solid #eee;
  }
  td:first-of-type {
    text-align: left;
  }
`;

export const PrintSectionHeader = styled.div`
  padding: 15px 0;
  font-weight: bold;
  border-top: 1px solid #000;
  text-transform: uppercase;
`;

export const PrintDocFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 32px;
  padding-top: 12px;
  border-top: 1px solid #a8acbb;
  font-size: 11px;
  color: #666;
`;

export const PrintSignatureGrid = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 32px;
  font-size: 12px;
  gap: 48px;
`;

export const PrintSignatureColumn = styled.div`
  flex: 1;
`;

export const PrintSignatureLine = styled.div`
  margin-bottom: 24px;
  label {
    display: block;
    font-weight: bold;
    margin-bottom: 4px;
  }
`;

export const PrintSignatureUnderline = styled.div`
  border-bottom: 1px solid #999;
  margin-top: 20px;
  width: 80%;
`;

export default {
  PrintWrapper,
  PrintOnly,
  NoPrint,
};
